import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import {
    MarketingSettingsPageTitles,
    MarketingMainSettingsRoutes,
    MarketingRouteStore,
    MarketingSection,
    MfeBasenames,
    MarketingMfe,
} from '@servicetitan/marketing-global-route';
import { ActionMenu, Icon, Stack, Text } from '@servicetitan/design-system';
import { observer } from 'mobx-react';
import { useDependencies } from '@servicetitan/react-ioc';
import { FeaturesStore } from '../../../features/stores/features.store';

import * as Styles from './header.module.less';

export const SettingsMenuDropdown = observer(() => {
    const [
        { getPathnameWithStandaloneRoot },
        {
            features: { isCustomizableAttributionWindowEnabled, isCustomizableCustomFieldsEnabled },
            isSMSRegistrationEnabled,
        },
    ] = useDependencies(MarketingRouteStore, FeaturesStore);

    const [state, setState] = useState(false);

    const handleToggle = useCallback(() => {
        setState(!state);
    }, [state]);

    const trigger = (
        <span className={Styles.navItem} onClick={handleToggle}>
            <Icon name="settings" className={classnames({ [Styles.active]: state })} size={24} />
            <ins>Settings</ins>
        </span>
    );

    return (
        <ActionMenu
            open={state}
            portal
            onClickOutside={handleToggle}
            trigger={trigger}
            icon={null}
            direction="bl"
            className="m-t-3 border-i"
        >
            <Stack className="p-b-1 p-t-1 p-l-3">
                <Text headline>Settings</Text>
            </Stack>
            <Link
                onClick={handleToggle}
                to={getPathnameWithStandaloneRoot(
                    MarketingSection.Settings,
                    `${MfeBasenames[MarketingMfe.MainSettings]}${MarketingMainSettingsRoutes.SettingsBrand}`,
                )}
                title="Company details"
            >
                <ActionMenu.Item>
                    {MarketingSettingsPageTitles[MarketingMainSettingsRoutes.SettingsBrand]}
                </ActionMenu.Item>
            </Link>
            <Link
                onClick={handleToggle}
                to={getPathnameWithStandaloneRoot(
                    MarketingSection.Settings,
                    `${MfeBasenames[MarketingMfe.MainSettings]}${MarketingMainSettingsRoutes.SettingsEmail}`,
                )}
                title="Email settings"
            >
                <ActionMenu.Item>
                    {MarketingSettingsPageTitles[MarketingMainSettingsRoutes.SettingsEmail]}
                </ActionMenu.Item>
            </Link>
            {isSMSRegistrationEnabled && (
                <Link
                    onClick={handleToggle}
                    to={getPathnameWithStandaloneRoot(
                        MarketingSection.Settings,
                        `${MfeBasenames[MarketingMfe.MainSettings]}${MarketingMainSettingsRoutes.SettingsSMS}`,
                    )}
                    title="SMS settings"
                >
                    <ActionMenu.Item>
                        {MarketingSettingsPageTitles[MarketingMainSettingsRoutes.SettingsSMS]}
                    </ActionMenu.Item>
                </Link>
            )}
            {isCustomizableAttributionWindowEnabled && (
                <Link
                    onClick={handleToggle}
                    to={getPathnameWithStandaloneRoot(
                        MarketingSection.Settings,
                        MfeBasenames[MarketingMfe.RevenueAttribution],
                    )}
                    title="Attribution Settings"
                >
                    <ActionMenu.Item>Attribution Settings</ActionMenu.Item>
                </Link>
            )}
            {isCustomizableCustomFieldsEnabled && (
                <Link
                    onClick={handleToggle}
                    to={getPathnameWithStandaloneRoot(
                        MarketingSection.Settings,
                        MfeBasenames[MarketingMfe.FieldsSettings],
                    )}
                    title="Fields Settings"
                >
                    <ActionMenu.Item>Fields Settings</ActionMenu.Item>
                </Link>
            )}
        </ActionMenu>
    );
});
